<div class="card">
    <app-header titulo="Perfis de Acessos" descricao=""></app-header>

    <div class="field">
        <label for="nome">Nome do Perfil:</label>
        <input id="nome" pInputText type="text" [(ngModel)]="perfil.nomePerfil" class="w-full" required autofocus>
        <small class="p-error" *ngIf="perfilEnviado && !perfil.nomePerfil">Nome é obrigatório.</small>
    </div>
        
    <div class="field ">
        <label for="nome">Permissões:</label>
            <p-tree 
                [value]="permissoes" 
                selectionMode="checkbox"
                [propagateSelectionUp]="true"
                [(selection)]="permissoesSelecionadas"
                (onNodeSelect)="onNodeSelect($event)" 
                (onNodeUnselect)="onNodeUnselect($event)"
                />
    </div>
    <div class="field col-2 pt-4">
        <button
          pButton
          icon="pi pi-save"
          class="p-button-success"
          [label]="perfil.id ? 'Atualizar' : 'Salvar'"
          (click)="salvar()"
        ></button>
      </div>
</div>